export enum RecipientChangeText {
  TITLE = 'Change Recipient to',
  SUBTITLE = "Once confirmed, the recipient's name & email will be updated in the form. This can be changed but cannot be reversed.",
  CHANGE_BUTTON_TEXT = 'Yes, change recipient',
}
